


























import Vue from "vue";
import {Component, Emit, Prop} from "vue-property-decorator";
import './stepper.less';

@Component({
    components: {
    }

})
export default class Stepper extends Vue {
    @Prop() steps;
    @Prop() currentStep;
    @Prop() maxStep;
    public percent = 0;
    public selectedStep = 0;
    getLeft(){

        if(this.steps.length ==3){
            if(((100-this.percent)/2) != 0){
                return (100-this.percent)/2+'%'
            }else{
                return '50%'
            }
        }else{
            if(this.maxStep== 0){
                return '0%'
            }else if(this.maxStep== 1){
                return '16%'
            } if(this.maxStep== 2){
                return '33%'
            } if(this.maxStep== 3){
                return '50%'
            }
        }

    }
    mounted() {
        this.selectedStep = this.currentStep;
        this.updateActiveLine();
    }

    updated(){
        this.updateActiveLine();
    }

    getStepNumber(){
        if (this.steps){
            return this.steps;
        }else{
            return 0;
        }
    }
    getCurrentStep(){
        return this.selectedStep;
    }
    getMaxStep(){
        return this.maxStep;
    }
    updateActiveLine(){
        this.percent = (100/(this.steps.length-1))*(this.getMaxStep())
    }
    selectStepLocal(stepID){
        if(this.getMaxStep() >= stepID){
            this.selectedStep = stepID;
            this.onSelectStep(stepID);
        }
    }
    @Emit("selectedStep")
    onSelectStep(stepID) {
    }

}
